'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
var MAX_LIST_ITEMS = 4;

function getTotalPackCounts(packCounts) {
  return packCounts.reduce(function (total, packCount) {
    return total + packCount.get('count');
  }, 0);
}

var PackCounts = /*#__PURE__*/function (_PureComponent) {
  _inherits(PackCounts, _PureComponent);

  function PackCounts() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PackCounts);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PackCounts)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderPackCount = function (packCount, index, abbreviateList) {
      if (abbreviateList && index >= MAX_LIST_ITEMS) {
        return null;
      }

      var subType = packCount.get('subType');
      return React.createElement("span", {
        key: subType
      }, React.createElement(FormattedMessage, {
        message: "marketplacelib.packCounts.subTypes." + subType,
        options: {
          count: packCount.get('count')
        }
      }));
    };

    _this.renderOverflowText = function (packCounts, abbreviateList) {
      if (abbreviateList && packCounts.size > MAX_LIST_ITEMS) {
        return React.createElement("span", {
          className: "pack-counts-overflow-text"
        }, React.createElement(FormattedMessage, {
          message: "marketplacelib.packCounts.overflowText",
          options: {
            numberOfMoreTemplates: packCounts.size - MAX_LIST_ITEMS
          }
        }));
      }

      return null;
    };

    return _this;
  }

  _createClass(PackCounts, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          abbreviateList = _this$props.abbreviateList,
          packCounts = _this$props.packCounts,
          showHeader = _this$props.showHeader;
      return React.createElement("div", null, showHeader && React.createElement("h5", null, React.createElement(FormattedMessage, {
        message: "marketplacelib.packCounts.title",
        options: {
          count: getTotalPackCounts(packCounts)
        }
      })), React.createElement(UIList, {
        styled: true,
        className: "p-left-5"
      }, packCounts.map(function (packCount, index) {
        return _this2.renderPackCount(packCount, index, abbreviateList);
      })), this.renderOverflowText(packCounts, abbreviateList));
    }
  }]);

  return PackCounts;
}(PureComponent);

PackCounts.propTypes = {
  abbreviateList: PropTypes.bool,
  packCounts: PropTypes.instanceOf(Immutable.List).isRequired,
  showHeader: PropTypes.bool
};
PackCounts.defaultProps = {
  abbreviateList: false,
  showHeader: true
};
export { PackCounts as default };